import styled from 'styled-components'

const ChooseHorseModalSpecialRace = styled.div`
  .choose-horse-modal {
    background-color: ${({ theme }) => theme.color.neutral};
    clip-path: polygon(0 0, 100% 0, 100% 100%, 40px 100%, 0 calc(100% - 40px));
    padding: 14px 28px;
    position: relative;
    min-height: 300px;
    width: 760px;
    .close-btn {
      top: 10px;
      right: 10px;
      background-color: ${({ theme }) => theme.color.transparent};
      border: none;
      z-index: 1;
    }

    .btn-container {
      position: absolute;
      bottom: 40px;
      display: flex;
      left: 40%;
    }

    .race-name-container {
      margin-bottom: 16px;

      .race-name {
        font-size: 24px;
        line-height: 20px;
      }
      .gate-no {
        background-color: #267e5a;
        border-radius: 4px;
        font-size: 18px;
        padding: 2px 10px;
      }
    }
    .no-horse-title {
      font-size: 20px;
      color: #ffec3d;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 20px;
    }
    .line {
      border-bottom: 2px solid ${({ theme }) => theme.color.black};
    }

    .race-info-container {
      gap: 32px;
      font-size: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-transform: uppercase;

      .race-info-item {
        gap: 8px;

        .race-info-title {
          font-size: 14px;
          line-height: 14px;
        }

        .race-info-content {
          font-size: 16px;
          line-height: 19px;

          img {
            width: 15px;
            height: 15px;
            margin-top: -5px;
            margin-left: 3px;
          }
        }
      }
    }

    .search-horse-container {
      margin: 12px 0 12px 0;
      .search-title {
        font-size: 16px;
        line-height: 24px;
      }

      .search-input {
        background-color: ${({ theme }) => theme.color.neutralBackground};
        opacity: 0.85;
        width: 240px;
        font-size: 16px;
        margin-right: 20px;
      }

      .filter-type {
        height: 36px;
      }

      .search__box {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
    .no-horse {
      color: #a3a5ab;
      font-size: 18px;
      padding-top: 20px;
      height: 300px;
    }

    .horse-list-container {
      max-height: 450px;
      /* overflow-y: scroll; */
      gap: 10px;
      min-height: 180px;
      .horse-item {
        position: relative;
        .check-box {
          position: absolute;
          color: red;
          z-index: 99;
          line-height: 2px;
          .check-box-img:hover {
            cursor: pointer;
          }
        }
      }
    }

    .horse-list-container-clone {
      max-height: 450px;
      gap: 16px;
    }

    .text-title {
      color: white;
      text-align: center;
      font-size: 20px;
      padding: 4px 0px;
    }
    .text-confirm-container {
      display: flex;
      justify-content: center;
      padding-top: 14px;
      .register-horse {
        .text-confirm {
          color: white;
          font-size: 20px;
          line-height: 24px;
        }
        .btn-group {
          padding-top: 14px;
          display: flex;
          justify-content: space-around;
          width: 100%;
          .back-btn,
          .confirm-btn {
            border: 0;
            background: none;
            padding: 0;
          }
        }
      }
    }

    .guild-info {
      display: flex;
      justify-content: center;
      align-items: center;
      .head-guild {
        display: flex;
        align-items: center;
        gap: 5px;
        color: white;
        background: linear-gradient(
          90deg,
          rgba(18, 21, 32, 0) 0%,
          rgba(78, 242, 125, 0.4) 51.04%,
          rgba(18, 22, 33, 0) 100%
        );
        padding: 0px 40px;
        margin-bottom: 10px;
        span {
          font-size: 20px;
        }

        img {
          width: 29px;
          height: 29px;
          border-radius: 100%;
        }
      }
    }

    .infinite-scroll-component::-webkit-scrollbar-track {
      border: 1px solid #000;
      padding: 2px 0;
      background-color: #000;
    }

    .infinite-scroll-component::-webkit-scrollbar {
      width: 5px;
    }

    .infinite-scroll-component::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      background-color: #2f323e;
      border: 1px solid #000;
    }
  }
`

export default ChooseHorseModalSpecialRace
